import LabeledContainer from '../../../components/LabeledContainer'
import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ItemWrapper from '../../../components/ItemWrapper'
import PageEmpty from '../../../components/PageEmpty'
import EducationItem from './EducationItem'
import { Box, Group, Text, ThemeIcon } from '@mantine/core'
import { IconSchool, IconTrendingUp } from '@tabler/icons-react'
import { useTheme } from '../../../components/ThemeProvider'

export default function TianyuanEducationInfo({ data, title }: { data: any; title: string }) {
  const theme = useTheme()
  const jsonData = JSON.parse(data.tianyuan_education_info ?? '{}')
  const educationList = jsonData?.data ?? []

  return (
    <ReportWrapper>
      <LabeledContainer title={title} />

      {/* Statistics Header */}
      {educationList.length > 0 && (
        <Box
          p="md"
          mb="lg"
          style={{
            background: theme?.primaryColor,
            borderRadius: '12px',
            color: 'white',
            boxShadow: `0 4px 15px ${theme?.primaryColor ? `${theme?.primaryColor}33` : 'rgba(102, 126, 234, 0.3)'}`,
          }}
        >
          <Group justify="space-between" align="center">
            <Group gap="md">
              <ThemeIcon size="lg" variant="white" color="white" radius="md">
                <IconSchool size={24} color={theme?.primaryColor || '#667eea'} />
              </ThemeIcon>
              <Box>
                <Text size="lg" fw={600} c="white">
                  学历档案
                </Text>
                <Text size="sm" c="rgba(255,255,255,0.8)">
                  共发现 {educationList.length} 条教育经历记录
                </Text>
              </Box>
            </Group>

            <Group gap="xs">
              <ThemeIcon size="sm" variant="white" color="white" radius="md">
                <IconTrendingUp size={16} color={theme?.primaryColor || '#667eea'} />
              </ThemeIcon>
              <Text size="sm" c="white" fw={500}>
                教育背景分析
              </Text>
            </Group>
          </Group>
        </Box>
      )}

      <ItemWrapper>
        {educationList.length === 0 && (
          <Box
            p="xl"
            style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              borderRadius: '12px',
              border: '2px dashed #cbd5e0',
            }}
          >
            <PageEmpty />
            <Text ta="center" size="sm" c="dimmed" mt="md">
              未找到相关的学历信息记录
            </Text>
          </Box>
        )}
        {educationList.map((item: any, index: number) => {
          return <EducationItem number={index + 1} key={index} item={item} />
        })}
      </ItemWrapper>
    </ReportWrapper>
  )
}
